import { Select } from "antd";
import useFetchAllExchangesWithCoins from "../hooks/api/useFetchAllExchangesWithCoins";
import capitalize from "antd/es/_util/capitalize";

function SelectExchange({
  value,
  onChange,
  style = {},
  loading = false,
  disabled = false,
  useCase = "",
}) {

  const {
    allExchangesWithCoins,
    isLoading,
    exchangeList: allExchanges,
  } = useFetchAllExchangesWithCoins();

  return (
    <Select
      // placeholder={
      //   exchangesLoading || loading ? "Loading..." : "Select an exchange"
      // }
      placeholder={
        !allExchangesWithCoins?.length && isLoading
          ? "Loading..."
          : "Select an exchange"
      }
      value={value || "Select an exchange"}
      onChange={(e) => onChange(e)}
      // disabled={exchangesLoading || loading}
      disabled={!allExchangesWithCoins?.length && isLoading}
      style={style}
      optionFilterProp="children"
      showSearch
      filterOption={(input, option) =>
        (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
      }
    >
      {/*{exchangesList?.map((exchange) => (*/}
      {allExchanges?.map((exchange) => (
        // <Select.Option key={exchange.id} value={exchange.id}>
        <Select.Option key={exchange} value={capitalize(exchange)}>
          {/*<LazyLoadImage*/}
          {/*  src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${exchange.id}.svg`}*/}
          {/*  alt={exchange.name}*/}
          {/*  width="25px"*/}
          {/*  height="25px"*/}
          {/*  effect="blur"*/}
          {/*/>*/}
          {/*{exchange.name}*/}
          {capitalize(exchange)}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectExchange;
